import { createFileRoute } from "@tanstack/react-router";

import TeamFormPage from "~/pages/friends/TeamFormPage.tsx";

export const Route = createFileRoute("/_auth/friends/teams/$teamId/edit")({
    component: TeamFormPage,
});
